export default {
  'login.pageTitle': 'Login',
};
